import { useMutation } from "@tanstack/react-query";
import { axiosCoreInstance } from "src/config/axios";
import { CompanyUserModel } from "../../types/CompanyUser";

export interface UserInvitationRejectRequest {
    invitationId?: number;
}

interface OwnProps {
    onSuccess?: () => void;
}

export const useUserInvitationRejectMutation = ({ onSuccess }: OwnProps) => {
    return useMutation(
        async (values: UserInvitationRejectRequest) => {
            if (values.invitationId) {
                const { data }: { data: CompanyUserModel } = await axiosCoreInstance.delete(
                    `api/user/invitation/${values.invitationId}`
                );
                return data;
            }
            return null;
        },
        {
            onSuccess: () => {
                if (onSuccess) {
                    onSuccess();
                }
            },
        }
    );
};
